import { Component, Vue, Watch } from 'vue-property-decorator';

import { Regexp } from '@/utils/validate';
import { RoleMgr } from '@/api/index';

@Component
export default class RoleList extends Vue {
  private searchValue: string = ''; // 搜索框绑定Value
  private rolesTableDate: object[] = []; // 角色列表表格数据
  private rolesTreeDate: object[] = []; // 角色权限树数据
  // 角色列表TABLE列设置
  private roleColumns: object[] = [
    {prop: 'roleName', title: '角色名称' },
    {prop: 'remark', title: '角色描述', showTooltip: true},
    {prop: 'createTime',  title: '创建时间', filter: 'time'}
  ];
  // 分页
  private page: any = {
    currPage: 1,
    size: 10,
    total: 0,
    sizes: [10, 20, 50, 100],
    layout: 'total, sizes, prev, pager, next, jumper'
  };
  // 角色权限树默认Props
  private defaultProps: object = {label: 'title', children: 'childs'};
  // 初始化调用方法
  private created() {
    this.getRolesTableDate();
    this.getRolesTreeDate();
  }
  // 搜索按钮Click事件
  private searchClick() {
    this.getRolesTableDate();
  }
  // 获取角色列表
  private getRolesTableDate(currPage = 1) {
    this.page.currPage = currPage;
    RoleMgr.getRoleList(this.searchValue, this.page.currPage, this.page.size).then(res => {
      this.rolesTableDate = res.data;
      this.page.total = parseInt(res.headers.total, 10);
    });
  }
  // 分页条数Change事件
  private pageSizeChange(value) {
    this.page.size = value;
    this.getRolesTableDate();
  }
  // 当前页Change事件
  private currentPageChange(value) {
    this.getRolesTableDate(value);
  }
  // 获取角色权限树
  private getRolesTreeDate() {
    RoleMgr.getRoleTree().then(res => {
      this.rolesTreeDate = res.data;
    });
  }
  // 获取选中角色节点的Keys
  private getCheckedRoleNode() {
    this.optRoleForm.menuIdList = (this.$refs.rolesTreeDate as any).getCheckedKeys();
  }
  // 新建角色
  private addRole() {
    this.optRoleKey = 'add';
    this.LoadOptRoleForm(null);
  }
  // 编辑角色
  private editRole(role) {
    this.optRoleKey = 'edit';
    this.LoadOptRoleForm(role);
  }
  // 删除角色
  private deleteRole(role) {
    this.$confirm('确定删除该角色？', '删除角色', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      RoleMgr.deleteRole(role.roleId).then(() => {
        this.optRoleKey = 'add';
        this.clearRoleForm();
        this.getRolesTableDate();
      });
    });
  }
  /********** 新建/编辑相关OPTROLE **********/
  private optRoleKey = 'add'; // 操作角色的KEY
  private optRoleForm: any = {
    roleId: '',
    roleName: '',
    remark: '',
    menuIdList: []
  }; // 新建/编辑角色Form表单
  private invalid: boolean = true; // 保存按钮是否可点
  // 加载新建/编辑角色Form表单
  private LoadOptRoleForm(role) {
    this.clearRoleForm();
    if (this.optRoleKey === 'edit') {
      this.optRoleForm.roleId = role.roleId;
      this.optRoleForm.roleName = role.roleName;
      this.optRoleForm.remark = role.remark;
      this.optRoleForm.menuIdList = role.menuIdList;
      setTimeout(() => {
        (this.$refs.optRoleForm as any).validate();
      }, 300);
    }
  }
  // 表单验证规则
  get roleRules(): object {
    return {
      roleName: [ Regexp().required, Regexp().maxLength(50), Regexp().minLength(2) ],
      menuIdList: [ Regexp().required ]
    };
  }
  // 实时验证表单 判断确定按钮是否可用
  private validateForm() {
    this.invalid = (this.$refs.optRoleForm as any).fields.some((e: any) =>
      e.isRequired ? e.validateState !== 'success' : e.validateState === 'error'
    );
  }
  // 保存按钮
  private saveRole() {
    const params: any = {
      roleId: this.optRoleForm.roleId,
      roleName: this.optRoleForm.roleName,
      remark: this.optRoleForm.remark,
      menuIdList: this.optRoleForm.menuIdList
    };
    if (!this.optRoleForm.roleId) {
      RoleMgr.addRole(params).then(() => {
       this.clearRoleForm();
       this.getRolesTableDate();
      });
    } else {
      RoleMgr.updateRole(params).then(() => {
        this.clearRoleForm();
        this.getRolesTableDate();
      });
    }
  }
  // 清空Form数据
  private clearRoleForm() {
    this.optRoleForm.roleId = '';
    this.optRoleForm.roleName = '';
    this.optRoleForm.remark = '';
    this.optRoleForm.menuIdList = [];
    (this.$refs.rolesTreeDate as any).setCheckedNodes([]);
    setTimeout(() => {
      (this.$refs.optRoleForm as any)?.clearValidate();
    }, 300);
  }
}
